/* eslint-disable prefer-destructuring */
import { ClientUserUpdatePatch } from '@weblite/ts-action/client-user'
import { eventBasedSynchronizer } from '$logic/lib/sync/event-based'

const synchronizer = eventBasedSynchronizer<ClientUserUpdatePatch, true>(
  'clientUserSync',
  { merge: true },
)

export function set(patch: ClientUserUpdatePatch) {
  return synchronizer.set('me', patch)
}

export async function get() {
  const { items, ...rest } = await synchronizer.getAll()
  return { item: items[0]?.patch, ...rest }
}
